import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { DateTime } from 'luxon'
import React from 'react'

const useStyles = makeStyles(theme => ({
  inactive: {
    color: theme.palette.primary.main,
  },
  selected: {
    color: theme.palette.secondary.main,
  },
  text: {
    fontSize: '0.563rem',
    fontWeight: 400,
    letterSpacing: '0.063em',
    textTransform: 'uppercase',
  },
}))

const ReleasePhaseDate = ({ selected, endsAt }: { endsAt: DateTime; selected: boolean }) => {
  const classes = useStyles()

  const endDay = endsAt.toLocaleString({ day: 'numeric' })
  const endMonth = endsAt.toLocaleString({ month: 'short' })
  const currentTime = DateTime.utc()
  const isExpired = endsAt < currentTime
  const text = isExpired ? 'sold out' : `Ends ${endMonth} ${endDay}`

  return (
    <Typography
      className={clsx(classes.text, {
        [classes.selected]: selected,
        [classes.inactive]: !selected,
      })}
    >
      {text}
    </Typography>
  )
}

export default ReleasePhaseDate
